import { BcHeaderWrapper, LetterAvatar } from "../../styled/global.styled";
import BcIcon from "../Bc-Icon/Bc-icon";
import { BcHeaderProps } from "../../interface/props/bcheader";
import ThemeSwitcher from "../Bc-ThemeSwitcher/Bc-ThemeSwitcher";
import { useService } from "../../../hook/useServices";
import { Auth } from "src/auth/auth";
interface UserView {
  username: string,
  initialLetter: string,
};

const getUser = async () => {
  const data = await Auth.currentAuthenticatedUser();
  return data?.username;
};

const getUserData = (userData: string): UserView => {
  if (userData !== undefined) {
    const username =  userData.split('@');

    return {
      username: username[0],
      initialLetter: username[0].charAt(0)
    }
  }

  return {
    username: 'invitado',
    initialLetter: 'I'
  }

}

const BcHeader = ({ onPress }: BcHeaderProps) => {


  const userQuery = useService('users', getUser);

  const username = (userQuery.data as string);

  const user = getUserData(username);


  return (
    <BcHeaderWrapper className="bc-header-wrapper">
      <header className="bc-header">
        <section className="bc-header-brand">
          <div
            className="bc-header-brand_menu-toggle bc-reverse-d-lg-none"
            onClick={onPress}
          >
            <BcIcon iconName="menu" />
            <span>Menú</span>
          </div>
          <BcIcon
            size="bc-2xl"
            ariaLabel="Bancolombia"
            iconName="bancolombia-horizontal"
            addClass="bc-header-brand-logo"
          />
          <BcIcon
            ariaLabel="isoBancolombia"
            iconName="isotipo-bancolombia"
            addClass="bc-icon-mobile"
          />
          <div className="bc-header-channel">
            <h5 aria-label="Sucursal Virtual Empresas">Brief</h5>
          </div>
        </section>
        <section>
          <ul className="bc-header-nav">
            <li className="bc-header-nav-item">
              <ThemeSwitcher />
            </li>

            <li className="bc-header-nav-item bc-header-br">
              <div
                className="bc-float-menu-toggle bc-icon bc-flex bc-align-items-center"
              >
                <div
                  className="bc-avatar bc-avatar-small"
                >
                  <LetterAvatar>
                    <p>
                    {user.initialLetter}
                    </p>
                  </LetterAvatar>
                  </div>
                <div className="bc-header-nav-item-text">
                  <p>{user.username}</p>
                </div>
              </div>
            </li>
          </ul>
        </section>
      </header>
    </BcHeaderWrapper>
  );
};

export default BcHeader;
